import React from 'react';
import { Monitor, Download, ExternalLink } from 'lucide-react';
import { AppButton } from '../ui';
import { getBaseUrl } from '../../utils/getBaseUrl';

// Served by the API, not the sales site: this card renders on lms.lmscampus.com
// and on every institute's custom domain, and the API base is the one address
// all of them share. The endpoint redirects to the current build on R2.
const downloadUrl = (platform) => `${getBaseUrl()}/public/desktop-app/download/${platform}`;

const DOWNLOADS = [
  { platform: 'win', label: 'Download for Windows' },
  { platform: 'mac', label: 'Download for Mac' },
];

// userAgentData is Chromium-only; navigator.platform is deprecated but is what
// Safari and Firefox still report ("MacIntel", on Apple Silicon too).
const isMac = () => /mac/i.test(navigator.userAgentData?.platform || navigator.platform || '');

const DesktopAppRequired = () => {
  // The student's own OS first, as the primary button.
  const primary = isMac() ? 'mac' : 'win';
  const downloads = [
    ...DOWNLOADS.filter((d) => d.platform === primary),
    ...DOWNLOADS.filter((d) => d.platform !== primary),
  ];

  return (
    <div className="tw-flex tw-min-h-[340px] tw-items-center tw-justify-center tw-p-8">
      <div className="tw-max-w-[480px] tw-rounded-xl tw-border tw-border-line tw-bg-surface-raised tw-px-8 tw-py-10 tw-text-center">
        <div className="tw-mb-5 tw-inline-flex tw-h-[72px] tw-w-[72px] tw-items-center tw-justify-center tw-rounded-full tw-bg-surface-alt tw-text-content">
          <Monitor size={40} />
        </div>

        <h3 className="tw-mb-3 tw-text-xl tw-font-semibold tw-text-content">Desktop App Required</h3>

        <p className="tw-mb-6 tw-text-sm tw-leading-relaxed tw-text-content-muted">
          Your institute requires the <strong>LMS Campus Desktop App</strong> for
          secure video playback. All other features (courses, assignments, coding
          practice, etc.) work normally in your browser.
        </p>

        <div className="tw-mb-5 tw-flex tw-flex-wrap tw-justify-center tw-gap-3">
          {/* A navigation, not window.open: the response is an installer, so the
              browser saves it and the student stays on this page. */}
          {downloads.map(({ platform, label }) => (
            <AppButton
              key={platform}
              variant={platform === primary ? 'default' : 'outline'}
              onClick={() => window.location.assign(downloadUrl(platform))}
            >
              <Download size={16} /> {label}
            </AppButton>
          ))}
        </div>

        <p className="tw-m-0 tw-flex tw-items-center tw-justify-center tw-gap-1.5 tw-text-[0.8rem] tw-text-content-subtle">
          <ExternalLink size={14} />
          Already installed? Open the desktop app and navigate to this course.
        </p>
      </div>
    </div>
  );
};

export default DesktopAppRequired;
